import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-demand",
  "use": "icon-user-demand-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"icon-user-demand\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFF\" opacity=\".01\" d=\"M0 0h34v34H0z\" /><path d=\"M13 15h4a2 2 0 000-4h-4a2 2 0 000 4m8 4h-8a2 2 0 000 4h8a2 2 0 000-4\" fill=\"#CF001F\" /><path d=\"M27.258 1H6.741a3.742 3.742 0 00-3.74 3.742v24.517a3.741 3.741 0 003.74 3.74h20.517A3.742 3.742 0 0031 29.26V4.742A3.743 3.743 0 0027.258 1zM7 29h20V5H7v24z\" fill=\"#333\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol